import React, { useState } from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Keyboard } from 'swiper';
import { formatImageWebpAuto } from '@ifeng-fe/public_method';
import 'swiper/css';
import Style from './index.css';

const Page2 = (props) => {
    const { peopleList, onChangeMaskVisible, onChangeCurrentVideo, index } = props;
    const [peopleIndex, setPeopleIndex] = useState(0);

    const openVideo = (video) => {
        onChangeCurrentVideo({
            url: video.videoUrl,
            duration: video.videoDuration,
            guid: video.videoGuid,
        });
        onChangeMaskVisible(true);
    };

    return (
        <div className={Style.page2}>
            <div className={Style.swiperWp}>
                <div className={`${Style.navigation} ${Style.prev} ${Style.next}`} id="page2_prev" />

                <Swiper
                    key={'video'}
                    modules={[Navigation, Pagination, Keyboard]}
                    className={Style.swiper}
                    slidesPerView={3}
                    slidesPerGroup={3}
                    speed={1500}
                    navigation={{
                        prevEl: '#page2_prev',
                        nextEl: '#page2_next',
                    }}
                    pagination={{
                        el: `.${Style.pagination}`,
                        type: 'fraction',
                    }}
                    keyboard={{
                        enabled: true,
                    }}>
                    {peopleList[index]?.videoList.map((video, index) => {
                        return (
                            <SwiperSlide key={index}>
                                <div className={Style.swiperItem} onClick={() => openVideo(video)}>
                                    <div className={Style.video}>
                                        <img className={Style.poster} src={formatImageWebpAuto(video.poster, 450, 244)} />
                                        <img className={Style.play} src={require('@src/common/assets/playbtn.png')} />
                                    </div>
                                    <div className={Style.title}>{video.title}</div>
                                </div>
                            </SwiperSlide>
                        );
                    })}
                </Swiper>

                <div className={`${Style.navigation} ${Style.next}`} id="page2_next" />
            </div>
            <div className={Style.pagination} />
        </div>
    );
};

Page2.propTypes = {
    peopleList: PropTypes.array,
    onChangeMaskVisible: PropTypes.func,
    onChangeCurrentVideo: PropTypes.func,
    index: PropTypes.number,
};

export default errorBoundary(Page2);
